@use '../../../../design-tokens/border-radius/border-radius' as *;
@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .tooltip {
    pointer-events: none;
  }

  .tooltipRoot {
    position: absolute;
    top: 40px;
    width: 1px;
    height: 1px;
  }

  .tooltipLabelContainer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 313px;
    padding: 8px 6px;
    box-sizing: border-box;
  }

  .dateLabel {
    @include typography-v2-title-sm;
  }

  .tooltipRow {
    display: flex;
    justify-content: space-between;
    @include typography-v2-body-xs;
  }

  .tooltipLegend {
    display: flex;
    align-items: center;
  }

  .tooltipLegendColor {
    width: 8px;
    height: 8px;
    border-radius: border-radius(full);
    margin-right: 8px;
  }

  .tooltipLegendColorDashed {
    width: 12px;
    height: 1px;
    background: none;
    border-bottom-style: dashed;
    border-bottom-width: 1.5px;
    border-radius: unset;
  }
}
